// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import React from "react";
import styled from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-n1lfg4-0"
})(["min-width:", ";max-width:", ";height:", ";"], ({
  $size
}) => $size, ({
  $size
}) => $size, ({
  $size
}) => $size);

/**
 * Navigation aid to direct user to additional operations forward or next or to the right.
 *
 * @param {object} props - The component props
 * @param {string} [props.size] - The width/height of the icon as any CSS size unit
 * @param {string} [props.color] - The fill color of the icon as any CSS color value
 * @param {string} [props.title] - The title to add as a child of the root svg element
 *
 * @returns {React.ReactElement} - The ChevronRightLarge component
 */
const ChevronRightLarge = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/_jsxs(SVG, {
  ...props,
  $size: size,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation',
  children: [title ? /*#__PURE__*/_jsx("title", {
    children: title
  }) : null, " ", /*#__PURE__*/_jsx("path", {
    fill: color,
    d: "M16.678 11.9L8.37 3.592a.75.75 0 1 1 1.06-1.06l8.836 8.834a.782.782 0 0 1 .002.002.745.745 0 0 1 .004 1.057l-.006.006-8.837 8.837a.745.745 0 0 1-1.06 0 .75.75 0 0 1 .001-1.063l8.307-8.307z",
    children: " "
  })]
});
export default ChevronRightLarge;